import { Vue } from 'vue-property-decorator';
import moment from 'moment';

Vue.filter('formatTime', (time, str = 'YYYY-MM-DD HH:mm:ss') => {
  if (!time) { return ''; }
  const m = moment(time);
  return m.isValid() ? m.format(str) : time;
});
